export function getWorkflowTypeLabel(workflowType?: string): string {
  switch (workflowType) {
    case 'opportunity_workflow':
      return 'Opportunity Workflows';
    case 'assistance_workflow':
      return 'Assistance Workflows';
    default:
      return '';
  }
}

export function getTaskTypeLabel(type?: string): string {
  switch (type) {
    case 'task':
      return 'Custom Task';
    case 'order_taking':
      return 'Order Taking';
    case 'note_taking':
      return 'Note Taking';
    case 'call_transfer':
      return 'Call Transfer';
    case 'general_inquiry':
      return 'General Inquiry';
    case 'end_call':
      return 'End Call';
    default:
      return type ? type.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase()) : '';
  }
}
